import { css } from '@linaria/core';
export const Root = {
    base: css `
		&& {
			color: rgb(var(--label-color-label-secondary));
			background-color: rgb(var(--label-color-background-secondary));
		}
	`,
};
export const LiveLabel = {
    base: css `
		&&&& {
			color: rgb(var(--label-color-label-live)) !important;
			background: rgb(var(--label-color-background-live)) !important;
		}
	`,
};
